<!--
 * @Description: 
 * @Autor: Dai YueLin
 * @Date: 2022-08-31 14:33:36
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-09-14 14:09:56
-->
<template>
  <n-button
    class="save_btn"
    :loading="props.loading"
    :type="(props.type as any)"
    :ghost="props.ghost"
    :theme-overrides="themeOverrides"
  >
    <slot></slot>
  </n-button>
</template>

<script lang="ts" setup>
import { NButton } from 'naive-ui';

const props = defineProps({
  type: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  ghost: {
    type: Boolean,
    default: false,
  },
});

const themeOverrides = {
  // colorPrimary: '#572DF3',
  // borderPrimary: '#572DF3',
  // textColor: '#666',
  // borderColor: '#BBB',
};
</script>

<style lang="scss">
.save_btn {
  width: 110px;
}
</style>
